var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRocketBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 68 68",
    style: {
      enableBackground: "new 0 0 68 68"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#2680EB;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M29.1,48.7c-1.4,1.4-2,3.3-2,5.1c0.1,4,7.4,13.4,7.4,13.4s7-9.6,6.9-13.6c0-1.8-0.8-3.6-2.2-5 C36.4,45.8,31.8,45.9,29.1,48.7z M36.6,53.6c0,0.9-2.3,5-2.3,5s-2.5-3.9-2.5-4.9c0-0.6,0.2-1.2,0.6-1.7c0.9-0.9,2.4-1,3.4-0.1 C36.4,52.4,36.6,53,36.6,53.6z M45.7,26.9L45.7,26.9c-0.4-21.4-12.4-26-12.4-26s-11.8,5-11.4,26.4l-5,3.4c-1.3,0.9-2.1,2.4-2.1,4 l0.3,13.7l11.9-5l14.1-0.3l12.1,4.6L53,34.1c0-1.6-0.8-3.1-2.2-3.9L45.7,26.9z M24.3,39.4l-4.6,1.9l-0.1-6.6l2.9-2 C22.9,35,23.6,37.3,24.3,39.4z M48.3,40.8L43.7,39c0.6-2.1,1.2-4.4,1.5-6.8l3,1.9L48.3,40.8z M40.9,27c0.1,4.5-1.5,9.8-2,11.5 L29,38.6c-0.6-1.6-2.3-6.9-2.4-11.4c-0.3-15.8,6.8-20.7,6.8-20.7S40.6,11.2,40.9,27z M37.1,26.6c1.8-1.9,1.8-4.9-0.1-6.7 c-1.9-1.8-4.9-1.8-6.7,0.1s-1.8,4.9,0.1,6.7C32.3,28.6,35.3,28.5,37.1,26.6z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocketBlue);
export default __webpack_public_path__ + "static/media/rocket_blue.ec485fe0dc8030d1692ee8f9c62dc197.svg";
export { ForwardRef as ReactComponent };